import { render, staticRenderFns } from "./BrowseTotalItemsResult.vue?vue&type=template&id=c4804d94&scoped=true"
import script from "./BrowseTotalItemsResult.vue?vue&type=script&lang=ts"
export * from "./BrowseTotalItemsResult.vue?vue&type=script&lang=ts"
import style0 from "./BrowseTotalItemsResult.vue?vue&type=style&index=0&id=c4804d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4804d94",
  null
  
)

export default component.exports